export const slashCommands = {
  ASSIGN: '/tr',
  END_CHAT: '/end',
  CANNED_MESSAGES: '/cm',
  WRAP_UP: '/wr',
  CLOSE_EMAIL: '/close',
  CUSTOM_TAB: '/cs'
};
